export const adicionarProtocoloUrl = (url: string): string => {
  if (!url.includes('http://') && !url.includes('https://')) {
    return `${window.location.protocol}//${url}`;
  }
  return url;
};
